import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomTopView from "../../Components/CustomTopView";
import LeftSideNav from "../../Components/LeftSideNav";
import TopNavBar from "../../Components/TopNavbar";
import Strings from "../../Config/Strings";
import { AppConstants } from "../../Constants/AppConstants";
import { useUserRolePermission } from "../../Context/UserRolePermission/UserRolePermissionState";
import {
  getLoggedInUserDetailsAPI,
  getUserByRoleIdAPI,
  getUserDetailsAPI,
} from "../../Store/Action/UserAction";
import Colors from "../../theme/Colors";
import UserTable from "./Component/UserTable";

const UsersList = () => {
  const searchInputRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { userData } = useSelector((state) => state.user);
 
  const limit = AppConstants.limit;
  const rowsPerPageLabel = "Customer Per Page";

  const [pageNumber, setPageNumber] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchQuery, setSearchQuery] = useState("");

  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [users, setUsers] = useState([]);
  const [totalCount, setTotalCount] = useState(1);

  const handleChangePage = useCallback((event, newPage) => {
    setPageNumber(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(event.target.value);
    setPageNumber(0);
  }, []);

  const handleSearchChange = useCallback((event) => {
    setSearchQuery(event.target.value);
    setPageNumber(0);
  }, []);

  const onAddCustomers = useCallback(() => {
    navigate("/addUser");
  }, [navigate]);

  const onViewUsers = useCallback(
    (user) => {
      navigate(`/userDetails/${user?.user_id}`, { state: { user } });
    },
    [navigate]
  );

  const recordAfterSorting = users?.slice(
    pageNumber * rowsPerPage,
    (pageNumber + 1) * rowsPerPage
  );

  const userRolePermission = useUserRolePermission();

  useEffect(() => {
    dispatch(getLoggedInUserDetailsAPI({}));
  }, [dispatch]);

  useEffect(() => {
    const userDataAPI = async () => {
      try {
        if (userData?.data?.[0].user_role_name === Strings.Admin) {
          const params = {
            searchQuery: searchQuery || undefined,
            page: pageNumber || undefined,
            limit: limit || undefined,
          };

          dispatch(
            getUserDetailsAPI(params, (result) => {
             
              setUsers(result?.data || []);
              setTotalCount(result?.totalCount);

              if (searchInputRef.current) {
                searchInputRef.current.focus();
              }
            })
          );
        } else {
         
          dispatch(
            getUserByRoleIdAPI(userData?.data?.[0].user_role_id, (result) => {
             
              setUsers(result?.data);
            })
          );
        }
      } catch (error) {
        console.log("Failed to fetch users:", error);
      }
    };
    userDataAPI();
  }, [
    dispatch,
    limit,
    pageNumber,
    searchQuery,
    userData?.data?.user_role_id,
    userData?.data?.user_role_name,
  ]);

  useEffect(() => {
    setBreadcrumbs([{ key: "1", href: "/userList", text: "Customers" }]);
  }, [rowsPerPage]);

  return (
    <div style={mainContainerStyle}>
      <LeftSideNav />

      <div style={topContainerStyle}>
        <TopNavBar
          leftSideText={`Hello ${userData?.data?.[0].user_first_name}`}
          isDashboard={true}
        />

        <CustomTopView
          breadcrumbs={breadcrumbs}
          addButtonText={"Add Customer"}
          exportButtonText={"Export Customer"}
          rowsPerPage={rowsPerPage}
          handleRowsPerPageChange={handleChangeRowsPerPage}
          rowPerPageLabel={rowsPerPageLabel}
          onAddButtonClick={onAddCustomers}
          searchValue={searchQuery}
          onSearchChange={handleSearchChange}
        />

        <div style={tableContainerStyle}>
          <UserTable
            users={recordAfterSorting}
            onViewUserDetails={onViewUsers}
            rowsPerPage={rowsPerPage}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalItems={totalCount}
            userRolePermission={userRolePermission}
          />
        </div>
      </div>
    </div>
  );
};

const mainContainerStyle = {
  display: "grid",
  gridTemplateColumns: "15% 85%",
  height: "100vh",
  width: "100vw",
  overflow: "hidden",
};

const topContainerStyle = {
  backgroundColor: Colors.bgColor,
  display: "flex",
  flexDirection: "column",
  height: "100%",
};

const tableContainerStyle = {
  width: "fit-content",
  height: "100%",
  marginLeft: "25px",
  borderRadius: "10px",
  margin: 20,
};

export default UsersList;
